import { useEffect, useState } from "react";
import useSponsorGeneralConf from "../../hooks/sponsor-hooks/useSponsorGeneralConf.hook";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar";
import SponsorModal from "../../components/SponsorModal";
import AuspicienteModel from "../../domain/models/auspiciante.model";


const SponsorView = () => {
    const navigate = useNavigate();
    const { loaders, data, actions } = useSponsorGeneralConf();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedSponsor, setSelectedSponsor] = useState<AuspicienteModel | null>(null);

    useEffect(() => {
        actions.fetchSponsors();
    }, []);

    const handleCreate = () => {
        setSelectedSponsor(null);
        setIsModalOpen(true);
    };

    const handleEdit = (id: number) => {
        const sponsor = data.sponsors.find(s => s.id === id);
        if (sponsor) {
            setSelectedSponsor(sponsor);
            setIsModalOpen(true);
        }
    };

    const handleDelete = async (id: number) => {
        if (window.confirm('¿Está seguro de que desea eliminar este auspiciante?')) {
            await actions.deleteSponsorHandler(id);
        }
    };

    const handleModalSave = async (sponsor: AuspicienteModel) => {
        if (selectedSponsor && selectedSponsor.id) {
            // Actualizar
            await actions.updateSponsorHandler({ ...sponsor, id: selectedSponsor.id });
        } else {
            // Crear
            await actions.createSponsorHandler(sponsor);
        }
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedSponsor(null);
    };

    return (
        <div className="background-colored">
            <div className="row justify-content-center">
                <div className="col-12 col-sm-2 justify-content-center sidebar">
                    <Sidebar />
                </div>
                <div className="col-12 col-sm-9 justify-content-center datatable-container ml">
                    <div className="header-container">
                        <div>
                            <span id="customized" className="header-label">
                                Auspiciantes{" "}
                            </span>
                        </div>
                        <button 
                            className="btn btn-primary-custom"
                            onClick={handleCreate}
                        >
                            Crear nuevo
                        </button>
                    </div>
                    <div className="mt-4 scroll-container">
                        <table className="table table-striped text-center">
                            <thead>
                                <tr>
                                    <th scope="col" className="th">
                                        Nombre
                                    </th>
                                    <th scope="col" className="th">
                                        Acciones
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {loaders.isLoadingData ? (
                                    <tr>
                                        <td colSpan={7} className="text-center">
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only"></span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : data.sponsors.length > 0 ? (
                                    data.sponsors.map((sponsor) => (
                                        <tr key={sponsor.id}>
                                            <td>{sponsor.nombre}</td>
                                            <td>
                                                <button
                                                    className="btn btn-warning btn-sm me-2"
                                                    onClick={() => handleEdit(sponsor.id!)}
                                                    title="Editar"
                                                >
                                                    <i className="fa fa-edit"></i>
                                                </button>
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleDelete(sponsor.id!)}
                                                    title="Eliminar"
                                                >
                                                    <i className="fa fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={7} className="text-center text-muted">
                                            No hay auspiciantes disponibles
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <SponsorModal
                isOpen={isModalOpen}
                onClose={handleModalClose}
                onSave={handleModalSave}
                sponsor={selectedSponsor}
                isLoading={loaders.isLoadingData}
            />
        </div>)
}

export default SponsorView;